import { Alert, Button, Col, Form, Image, Input, Modal, Row, Select, Table, Tooltip, Upload } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useRef, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, UploadOutlined, SendOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { dateFormat } from '../../Utils/formatDate';

function Notification() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [editorHtml, setEditorHtml] = useState("");
    const [fileList, setFileList] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const quillRef = useRef(null);

    const [divisionOptions, setDivisionOptions] = useState([]);
    const [loadingDivision, setLoadingDivision] = useState(false);
    const [divisionPage, setDivisionPage] = useState(1);
    const [divisionHasMore, setDivisionHasMore] = useState(true);
    const [divisionSearch, setDivisionSearch] = useState('');

    const [areaOptions, setAreaOptions] = useState([]);
    const [loadingArea, setLoadingArea] = useState(false);
    const [areaPage, setAreaPage] = useState(1);
    const [areaHasMore, setAreaHasMore] = useState(true);
    const [areaSearch, setAreaSearch] = useState('');


    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'notification_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const handleChange = (value) => {
        setEditorHtml(value);
    };

    const handleUploadChange = ({ fileList }) => {
        setFileList(fileList);
    };

    const titlePage = 'Notification Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: "title",
            sorter: true,
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => {
                return record.created_at ? (<p>{dateFormat(record.created_at)}</p>) : "-";
            }
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => {
                return record.updated_at ? (<p>{dateFormat(record.updated_at)}</p>) : "-";
            }
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: "image",
            render: (text) => text ? (<Image src={text} height={50} />) : "-"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <div className="table-action-group">
                    <Tooltip title="Send Notification">
                        <Button type="dashed" style={{ marginRight: 10 }} onClick={() => sendNotification(record)}>
                            <SendOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </div>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'notification_id';
        getApi("GET", `/notification?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`);
    }, [JSON.stringify(page), isAlert]);

    const fetchDivision = async (search = '', page = 1) => {
        setLoadingDivision(true);
        try {
            const res = await apiCall({
                method: 'GET',
                url: `/division?search=${search}&page=${page}&limit=20`,
                data: {
                    headers: { Authorization: 'Bearer ' + token },
                },
            });

            const data = res.data.data || [];
            setDivisionOptions(prev => page === 1 ? data : [...prev, ...data]);
            setDivisionHasMore(data.length === 20);
        } catch (e) {
            console.error("Fetch division error", e);
        }
        setLoadingDivision(false);
    };

    const fetchArea = async (search = '', page = 1) => {
        setLoadingArea(true);
        try {
            const res = await apiCall({
                method: 'GET',
                url: `/area?search=${search}&page=${page}&limit=20`,
                data: {
                    headers: { Authorization: 'Bearer ' + token },
                },
            });

            const data = res.data.data || [];
            setAreaOptions(prev => page === 1 ? data : [...prev, ...data]);
            setAreaHasMore(data.length === 20);
        } catch (e) {
            console.error("Fetch area error", e);
        }
        setLoadingArea(false);
    };

    const handleSearchDivision = (value) => {
        setDivisionSearch(value);
        setDivisionPage(1);
        fetchDivision(value, 1);
    };

    const handleScrollDivision = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 10 && divisionHasMore && !loadingDivision) {
            const nextPage = divisionPage + 1;
            setDivisionPage(nextPage);
            fetchDivision(divisionSearch, nextPage);
        }
    };

    const handleSearchArea = (value) => {
        setAreaSearch(value);
        setAreaPage(1);
        fetchArea(value, 1);
    };

    const handleScrollArea = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 10 && areaHasMore && !loadingArea) {
            const nextPage = areaPage + 1;
            setAreaPage(nextPage);
            fetchArea(areaSearch, nextPage);
        }
    };
    useEffect(() => {
        if (isModal) {
            fetchDivision('', 1);
            fetchArea('', 1);
        }
    }, [isModal]);

    const getApi = (method, url) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.total_data
                    }
                });
            }
            setLoading(false);
        }).catch((e) => {
            console.error(e.message);
            setLoading(false);
        });
    };

    const postApi = async (method, url, data) => {
        setLoading(true);
        setIsAlert(false);

        const dataReq = {
            method,
            url,
            data: {
                data: data,
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            }
        };

        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            console.error(e.message);
            setLoading(false);
        });
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Are you sure you want to delete this data?',
            onOk: () => postApi('DELETE', '/notification/' + v.notification_id),
        });
    };

    const sendNotification = (record) => {
        Modal.confirm({
            title: 'Confirmation',
            content: 'Are you sure you want to send this notification?',
            onOk: () => {
                postApi("POST", '/sendnotification/' + record.notification_id);
            }
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit') {
            setdataModal(data);
            setEditorHtml(data.desc_html);
            setImageFile(data.image);
            if (data.notification_image?.length > 0) {
                const files = data.notification_image.map((img, i) => ({
                    uid: String(-i - 1),
                    name: `image-${i}.jpg`,
                    status: 'done',
                    url: img.image
                }));
                setFileList(files);
            }
            form.setFieldsValue({
                title: data.title,
                desc: data.desc
            });
        }
        setIsModal(true);
    };

    const handleSubmit = async (type) => {
        const values = await form.validateFields();
        const formData = new FormData();

        formData.append('title', values.title);
        formData.append('desc', values.desc);
        formData.append('desc_html', editorHtml);
        if (values.division_ids && values.division_ids.length > 0) {
            formData.append('division', values.division_ids.join(','));
        }
        if (values.area_ids && values.area_ids.length > 0) {
            formData.append('area', values.area_ids.join(','));
        }


        if (imageFile && imageFile.originFileObj) {
            formData.append('image', imageFile.originFileObj);
        } else if (typeof imageFile === 'object') {
            formData.append('image', imageFile);
        }
        fileList.forEach((file) => {
            if (file.originFileObj) {
                formData.append('images', file.originFileObj);
            }
        });
        if (dataModal != null) {
            postApi("PUT", `/notification/${dataModal.notification_id}`, formData);
        } else {
            const url = type === 'send' ? 'sendnotification/' : '/notification';
            postApi("POST", url, formData);
        }
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        setEditorHtml('');
        setFileList([]);
        setImageFile(null);
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    return (
        <div className="responsive-page notification-page">
            <Helmet><title>{titlePage}</title></Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>{titlePage}</h3>
            <Row className="responsive-page-toolbar notification-toolbar" gutter={[12, 12]} align="middle">
                <Col xs={24} md={12} lg={8}>
                    <Search className="responsive-search" placeholder="Search" allowClear enterButton="Search" size="middle" onSearch={searchData} />
                </Col>
                <Col xs={24} md={12} lg={16} className="responsive-page-actions">
                    <Button className="responsive-primary-action" type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined /><b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey="notification_id"
            />
            <Modal title="Notification Form" width={800} open={isModal} onCancel={closeModal}
                footer={[
                    <Button key="back" onClick={closeModal}>Cancel</Button>,
                    <Button key="submit" type="primary" onClick={() => handleSubmit('save')}>Save</Button>,
                    <Button key="send" type="primary" icon={<SendOutlined />} onClick={() => handleSubmit('send')}>Save & Send</Button>
                ]}>
                <Form form={form} name="form" layout="vertical">
                    <Form.Item label="Upload Main Image">
                        <Upload
                            beforeUpload={() => false}
                            maxCount={1}
                            showUploadList={false}
                            onChange={(info) => setImageFile(info.file)}
                        >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                        <br />
                        {imageFile && (
                            <Image
                                src={typeof imageFile === 'string' ? imageFile : URL.createObjectURL(imageFile)}
                                alt="Preview"
                                style={{ width: 100, height: 100, objectFit: 'contain', border: '1px solid #ccc', borderRadius: 8, marginTop: 10 }}
                            />
                        )}
                    </Form.Item>
                    <Form.Item
                        name="title"
                        label="Title"
                        rules={[{ required: true, message: 'Title is required!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="desc"
                        label="Short Description"
                        rules={[{ required: false, message: 'Description is required!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label="Description">
                        <ReactQuill ref={quillRef} value={editorHtml} onChange={handleChange} modules={{ toolbar: [[{ 'header': '1' }, { 'header': '2' }, { 'font': [] }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['bold', 'italic', 'underline', 'strike'], ['link'], ['image']] }} />
                    </Form.Item>
                    <Form.Item label="Upload Additional Images">
                        <Upload
                            multiple
                            listType="picture"
                            fileList={fileList}
                            beforeUpload={() => false}
                            onChange={handleUploadChange}
                        >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        name="division_ids"
                        label="Divisions"
                        rules={[{ required: false }]}
                    >
                        <Select
                            mode="multiple"
                            showSearch
                            placeholder="Select Divisions"
                            onSearch={handleSearchDivision}
                            onPopupScroll={handleScrollDivision}
                            filterOption={false}
                            loading={loadingDivision}
                            options={divisionOptions.map((item) => ({
                                value: item.division_id,
                                label: item.name || item.division_name,
                            }))}
                        />
                    </Form.Item>

                    <Form.Item
                        name="area_ids"
                        label="Areas"
                        rules={[{ required: false }]}
                    >
                        <Select
                            mode="multiple"
                            showSearch
                            placeholder="Select Areas"
                            onSearch={handleSearchArea}
                            onPopupScroll={handleScrollArea}
                            filterOption={false}
                            loading={loadingArea}
                            options={areaOptions.map((item) => ({
                                value: item.area_id,
                                label: item.name || item.area_name,
                            }))}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default Notification;
